/* eslint-disable react/no-unescaped-entities */
import PublicPageLayout, { Section } from "@/components/PublicPageLayout";

export default function Privacy() {
  return (
    <PublicPageLayout
      eyebrow="Privacy"
      title="Privacy policy"
      intro="Plain-English summary of what we collect, why we collect it, and what you can do about it. Last updated February 2026."
      testid="privacy-page"
    >
      <Section title="1. Who we are" testid="privacy-who">
        <p>
          The AI Took My Job ("we", "us") is operated as a private service for Australian
          residents navigating AI-related career change. Contact: privacy@aitookmyjob.example.
        </p>
      </Section>

      <Section title="2. What we collect" testid="privacy-collect">
        <ul className="list-disc pl-6 space-y-2">
          <li>Account: email address, name, hashed password (if not using Google sign-in).</li>
          <li>Assessment answers: the 12-step questionnaire you complete voluntarily.</li>
          <li>
            Generated content: career reports, AI recommendations, government support eligibility
            indications and job matches we create for you.
          </li>
          <li>Activity: jobs you save, mark as applied, and notes you write.</li>
          <li>
            Billing metadata: Stripe customer ID, subscription status and last four digits of your
            card. We never see or store your full payment details.
          </li>
          <li>Technical: IP address, browser, and basic usage logs for security and uptime.</li>
        </ul>
        <p>
          We do <span className="font-medium">not</span> collect Tax File Numbers, Medicare
          numbers, government ID images, sensitive health information or biometrics.
        </p>
      </Section>

      <Section title="3. How we use your data" testid="privacy-use">
        <ul className="list-disc pl-6 space-y-2">
          <li>To run your assessment and generate your career report.</li>
          <li>To match you with relevant jobs and government support programs.</li>
          <li>To bill you, send service emails, and respond to support requests.</li>
          <li>To detect abuse, fraud and security incidents.</li>
        </ul>
        <p>We do not sell your data and do not run third-party advertising.</p>
      </Section>

      <Section title="4. AI providers" testid="privacy-ai">
        <p>
          Your structured assessment is sent to OpenAI, Anthropic and Google Gemini to generate
          your pathways. We send only the assessment content needed for the prompt — no name,
          email or account ID. All three providers operate under enterprise data agreements that
          prohibit training on inputs.
        </p>
      </Section>

      <Section title="5. Sharing & sub-processors" testid="privacy-share">
        <ul className="list-disc pl-6 space-y-2">
          <li>MongoDB Atlas — application database (Australian region).</li>
          <li>Stripe — payment processing.</li>
          <li>OpenAI, Anthropic, Google — AI generation (anonymised assessment only).</li>
          <li>Adzuna and other job boards — read-only job listing fetches.</li>
        </ul>
      </Section>

      <Section title="6. Your rights" testid="privacy-rights">
        <p>
          You can access, correct or delete your data at any time from your account. Under the
          Australian Privacy Act 1988 (Cth) you may also lodge a complaint with the Office of the
          Australian Information Commissioner (OAIC) if you believe we've mishandled your data.
        </p>
      </Section>

      <Section title="7. Retention" testid="privacy-retention">
        <p>
          We keep your account data for as long as your account is active. After you delete your
          account, data is removed from production within 7 days and from encrypted backups within
          30 days.
        </p>
      </Section>

      <Section title="8. Security" testid="privacy-security">
        <p>
          Data is encrypted in transit (TLS 1.2+) and at rest. Passwords are hashed with bcrypt.
          We follow least-privilege access for staff and review logs continuously.
        </p>
      </Section>

      <Section title="9. Changes" testid="privacy-changes">
        <p>
          If we materially change this policy, we'll email active subscribers at least 14 days
          before the change takes effect.
        </p>
      </Section>
    </PublicPageLayout>
  );
}
